<template>
  <v-data-table-server :headers="headers"
                       :items="dataSources"
                       v-model="selected"
                       v-model:items-per-page="itemsPerPage"
                       v-model:expanded="expanded"
                       v-model:sort-by="sortBy"
                       :items-length="totalItems"
                       :loading="loading"
                       :search="search"
                       select-strategy="single"
                       :row-props="rowProps"
                       :items-per-page-options="[15,25,50,100]"
                       :multi-sort="true"
                       @click:row="handleRowClicked"
                       @update:options="loadItems"
                       return-object
                       show-expand
                       show-select>
    <template v-slot:top>
      <v-toolbar color="secondary" flat>
        <v-toolbar-title class="text-button">Data Sources</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn variant="plain"
               v-if="hasAccessRight('data-landscaping-admin')"
               @click.stop="newItem()">New Item</v-btn>
        <v-btn variant="plain" icon="mdi-file-excel" :disabled="loading" @click.stop="downloadExcel"></v-btn>
        <v-divider :vertical="true"></v-divider>
        <v-label class="ms-4">Filters</v-label>
        <v-btn variant="text" icon="mdi-filter" @click.stop="filter_drawer = !filter_drawer"></v-btn>

        <v-dialog v-model="dialog" max-width="50%">
          <landscaping-data-source-details-card
              :data-source="currentItem"
              :current-version="currentVersion"
              :delta="currentDelta"
              :failure="failedLoadVersion"
              :customers="customers"
              v-on:next-version="loadNextVersion(this.currentItem, (patch, delta) => {
                this.currentItem = patch
                this.currentDelta = delta
              })"
              v-on:previous-version="loadPreviousVersion(this.currentItem, (patch, delta) => {
                this.currentItem = patch
                this.currentDelta = delta
              })"></landscaping-data-source-details-card>
          <v-row>
            <v-col cols="12">
              <ProgressBar mode="indeterminate" style="height: 4px" :hidden="!dialogDisabled"></ProgressBar>
            </v-col>
          </v-row>
          <v-card elevation="0" min-height="50">
            <v-card-actions>
              <v-btn variant="text" @click="close" :disabled="false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="newItemDialog" max-width="50%">
          <landscaping-data-source-edit-card ref="dataSourceNewItemCard"
                                             form-ref="dataSourceNewItemForm"
                                             :data-source="currentItem"
                                             :group-items="groupItems"
                                             :customers="customers"
                                             :therapeutic-area-items="allTherapeuticAreas"
                                             :country-items="allCountries"
                                             :geographical-set-up-items="allGeographicalSetUp"
                                             :data-source-type-items="allDataSourceTypes"
                                             :retrospective-or-prospective-collection-items="allRetrospectiveOrProspectiveCollection"
                                             :longitudinal-data-collection-items="allLongitudinalDataCollection"
                                             :outreach-performed-items="allOutreachPerformed"
                                             :disabled="dialogDisabled"
                                             :new-item="true"
                                             v-on:save="saveNewLandscapingDataSource($event, () => closeNewItemDialog())"></landscaping-data-source-edit-card>
          <v-row>
            <v-col cols="12">
              <ProgressBar mode="indeterminate" style="height: 4px" :hidden="!dialogDisabled"></ProgressBar>
            </v-col>
          </v-row>
          <v-card elevation="0" min-height="50">
            <v-card-actions>
              <v-label class="error me-5" v-if="failedSaveNewItem">{{failedSaveNewItem}}</v-label>
              <v-btn variant="text" @click="this.$refs.dataSourceNewItemCard.validateAndSave()" :disabled="dialogDisabled">Save</v-btn>
              <v-btn variant="text" @click="closeNewItemDialog" :disabled="dialogDisabled">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="editDialog" max-width="50%">
          <landscaping-data-source-edit-card ref="dataSourceEditCard"
                                             form-ref="dataSourceEditForm"
                                             :data-source="currentItem"
                                             :group-items="groupItems"
                                             :customers="customers"
                                             :therapeutic-area-items="allTherapeuticAreas"
                                             :country-items="allCountries"
                                             :geographical-set-up-items="allGeographicalSetUp"
                                             :data-source-type-items="allDataSourceTypes"
                                             :retrospective-or-prospective-collection-items="allRetrospectiveOrProspectiveCollection"
                                             :longitudinal-data-collection-items="allLongitudinalDataCollection"
                                             :outreach-performed-items="allOutreachPerformed"
                                             :disabled="dialogDisabled"
                                             v-on:save="saveEditedLandscapingDataSource($event, () => closeEditDialog())"
                                             v-on:modified="dialogModifiedData = $event"></landscaping-data-source-edit-card>
          <v-row>
            <v-col cols="12">
              <ProgressBar mode="indeterminate" style="height: 4px" :hidden="!dialogDisabled"></ProgressBar>
            </v-col>
          </v-row>
          <v-card elevation="0" min-height="50">
            <v-card-actions>
              <v-label class="error me-5" v-if="failedSaveEdit">{{failedSaveEdit}}</v-label>
              <v-btn variant="text" @click="this.$refs.dataSourceEditCard.validateAndSave()"
                     :disabled="dialogDisabled || !dialogModifiedData">Save</v-btn>
              <v-btn variant="text" @click="closeEditDialog" :disabled="dialogDisabled">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="compareDialog" max-width="75%">
          <v-sheet>
            <v-row>
              <v-col cols="6">
                <landscaping-data-source-details-card
                    :data-source="currentCompareItem"
                    :current-version="currentCompareItemVersion"
                    :delta="currentCompareItemDelta"
                    :failure="failedLoadVersion"
                    :customers="customers"
                    v-on:next-version="loadNextVersion(this.currentCompareItem, (patch, delta) => {
                        this.currentCompareItem = patch
                        this.currentCompareItemDelta = delta
                      })"
                    v-on:previous-version="loadPreviousVersion(this.currentCompareItem, (patch, delta) => {
                        this.currentCompareItem = patch
                        this.currentCompareItemDelta = delta
                      })"></landscaping-data-source-details-card>
              </v-col>
              <v-col cols="6">
                <landscaping-data-source-details-card
                    :data-source="currentItem"
                    :current-version="currentVersion"
                    :delta="currentDelta"
                    :failure="failedLoadVersion"
                    :customers="customers"
                    v-on:next-version="loadNextVersion(this.currentItem, (patch, delta) => {
                        this.currentItem = patch
                        this.currentDelta = delta
                      })"
                    v-on:previous-version="loadPreviousVersion(this.currentItem, (patch, delta) => {
                        this.currentItem = patch
                        this.currentDelta = delta
                      })"></landscaping-data-source-details-card>
              </v-col>
            </v-row>
          </v-sheet>
          <v-row>
            <v-col cols="12">
              <ProgressBar mode="indeterminate" style="height: 4px" :hidden="!dialogDisabled"></ProgressBar>
            </v-col>
          </v-row>
          <v-card elevation="0" min-height="50">
            <v-card-actions>
              <v-btn variant="text" @click="closeCompareDialog" :disabled="false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="compareEditDialog" max-width="75%">
          <v-sheet>
            <v-row>
              <v-col cols="6">
                <landscaping-data-source-details-card
                    :data-source="currentCompareItem"
                    :current-version="currentCompareItemVersion"
                    :delta="currentCompareItemDelta"
                    :failure="failedLoadVersion"
                    :customers="customers"
                    v-on:next-version="loadNextVersion(this.currentCompareItem, (patch, delta) => {
                        this.currentCompareItem = patch
                        this.currentCompareItemDelta = delta
                      })"
                    v-on:previous-version="loadPreviousVersion(this.currentCompareItem, (patch, delta) => {
                        this.currentCompareItem = patch
                        this.currentCompareItemDelta = delta
                      })"></landscaping-data-source-details-card>
              </v-col>
              <v-col cols="6">
                <landscaping-data-source-edit-card ref="dataSourceCompareEditCard"
                                                   form-ref="dataSourceCompareEditForm"
                                                   :data-source="currentItem" :customers="customers"
                                                   :group-items="groupItems"
                                                   :therapeutic-area-items="allTherapeuticAreas"
                                                   :country-items="allCountries"
                                                   :geographical-set-up-items="allGeographicalSetUp"
                                                   :data-source-type-items="allDataSourceTypes"
                                                   :retrospective-or-prospective-collection-items="allRetrospectiveOrProspectiveCollection"
                                                   :longitudinal-data-collection-items="allLongitudinalDataCollection"
                                                   :outreach-performed-items="allOutreachPerformed"
                                                   :disabled="dialogDisabled"
                                                   v-on:save="saveEditedLandscapingDataSource($event, () => closeCompareEditDialog())"
                                                   v-on:modified="compareEditDialogModifiedData = $event"></landscaping-data-source-edit-card>
              </v-col>
            </v-row>
          </v-sheet>
          <v-row>
            <v-col cols="12">
              <ProgressBar mode="indeterminate" style="height: 4px" :hidden="!dialogDisabled"></ProgressBar>
            </v-col>
          </v-row>
          <v-card elevation="0" min-height="50">
            <v-card-actions>
              <v-label class="error me-5" v-if="failedSaveEdit">{{failedSaveEdit}}</v-label>
              <v-btn variant="text" @click="this.$refs.dataSourceCompareEditCard.validateAndSave()"
                     :disabled="dialogDisabled || !compareEditDialogModifiedData">Save</v-btn>
              <v-btn variant="text" @click="closeCompareEditDialog" :disabled="dialogDisabled">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="deleteDialog" max-width="500px">
          <v-card>
            <v-card-title>Confirm delete</v-card-title>
            <v-card-text class="error" v-if="failedDelete">{{failedDelete}}</v-card-text>
            <v-card-text>Are you sure that you want to delete this data source?</v-card-text>
            <v-card-actions class="mt-10">
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="closeDeleteDialog">Cancel</v-btn>
              <v-btn variant="text" @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="restoreDialog" max-width="500px">
          <v-card>
            <v-card-title>Confirm restore</v-card-title>
            <v-card-text class="error" v-if="failedRestore">{{failedRestore}}</v-card-text>
            <v-card-text>Are you sure that you want to restore this data source?</v-card-text>
            <v-card-actions class="mt-10">
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="closeRestoreDialog">Cancel</v-btn>
              <v-btn variant="text" @click="restoreItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`header.data-table-select`]>
      <div>Compare</div>
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <div :style="renderDisabledStyle(item)">
        {{ item.name }}
      </div>
    </template>
    <template v-slot:[`item.country`]="{ item }">
      <v-chip-group :column="true">
        <v-chip v-for="country in item.country" :key="country" class="me-2" color="primary" size="small"
                :style="renderDisabledStyle(item)"
                :label="true" @click.stop="toggleAllOneCountries(country)">{{ country }}</v-chip>
      </v-chip-group>
    </template>
    <template v-slot:[`item.countryComment`]="{ item }">
      <div :style="renderDisabledStyle(item)">
        {{ item.countryComment }}
      </div>
    </template>
    <template v-slot:[`item.therapeuticArea`]="{ item }">
      <v-chip-group :column="true">
        <v-chip v-for="therapeuticArea in item.therapeuticArea" :key="therapeuticArea" class="me-2" color="primary" size="small"
                :style="renderDisabledStyle(item)"
                :label="true" @click.stop="toggleAllOneTherapeuticAreas(therapeuticArea)">{{ therapeuticArea }}</v-chip>
      </v-chip-group>
    </template>
    <template v-slot:[`item.geographicalSetUp`]="{ item }">
      <v-chip-group :column="true">
        <v-chip v-for="geographicalSetUp in item.geographicalSetUp" :key="geographicalSetUp" class="me-2" color="primary" size="small"
                :style="renderDisabledStyle(item)"
                :label="true" @click.stop="toggleAllOneGeographicalSetUp(geographicalSetUp)">{{ geographicalSetUp }}</v-chip>
      </v-chip-group>
    </template>
    <template v-slot:[`item.access`]="{ item }">
      <v-chip color="primary" size="small" :label="true" v-if="item.externalId && item.importSource">
        <v-icon class="me-2" size="small" color="warning" v-tooltip="'Imported data source'">
          mdi-account-alert-outline
        </v-icon>
        <div :style="renderDisabledStyle(item)">Imported</div>
      </v-chip>
      <v-icon size="small" color="primary-darken-1" v-tooltip="'Not imported'" v-else>
        mdi-earth
      </v-icon>
    </template>
    <template v-slot:[`item.data-table-expand`]="{ internalItem, toggleExpand, isExpanded }">
      <td>
        <v-btn variant="text" density="comfortable"
               @click.stop="toggleExpand(internalItem)"
               :icon="true">
          <v-icon v-tooltip="'Expand data source'" v-if="!isExpanded(internalItem)">mdi-chevron-down</v-icon>
          <v-icon v-tooltip="'Collapse data source'" v-else>mdi-chevron-up</v-icon>
        </v-btn>
      </td>
    </template>
    <template v-slot:expanded-row="{ columns, item }">
      <tr>
        <td :colspan="columns.length">
          <v-data-table
              density="compact"
              width="200px"
              :items-per-page="0"
              :headers="[{align: 'start', key: 'label', width: '20%'}, {align: 'start', key: 'value', width: '80%'}]"
              :items="[
                      {label: 'Data source type', value: item.dataSourceType, deleted: item.deleted, toggleFunction: toggleAllOneDataSourceType},
                      {label: 'Retrospective or Prospective collection', value: item.retrospectiveOrProspectiveCollection,
                      deleted: item.deleted, toggleFunction: toggleAllOneRetrospectiveOrProspectiveCollection},
                      {label: 'Longitudinal data collection', value: item.longitudinalDataCollection, deleted: item.deleted,
                      toggleFunction: toggleAllOneLongitudinalDataCollection},
                      {label: 'Outreach performed', value: item.outreachPerformed, deleted: item.deleted,
                      toggleFunction: toggleAllOneOutreachPerformed},
                      ]">
            <template #headers></template>
            <template #bottom></template>
            <template v-slot:[`item.label`]="{ item }">
              <div :style="renderDisabledStyle(item)">
                {{ item.label }}
              </div>
            </template>
            <template v-slot:[`item.value`]="{ item }">
              <div v-if="['Data source type'].includes(item.label)">
                <v-chip-group :column="true">
                  <v-chip v-for="value in item.value" :key="value" class="me-2"
                          :style="renderDisabledStyle(item)"
                          color="primary" size="small" :label="true"
                          @click.stop="item.toggleFunction(value)">
                    {{ value }}
                  </v-chip>
                </v-chip-group>
              </div>
              <div v-else-if="['Retrospective or Prospective collection', 'Longitudinal data collection', 'Outreach performed'].includes(item.label)">
                <v-chip-group :column="true">
                  <v-chip :style="renderDisabledStyle(item)"
                          color="primary" size="small" :label="true"
                          @click.stop="item.toggleFunction(item.value)">
                    {{ item.value }}
                  </v-chip>
                </v-chip-group>
              </div>
              <div :style="renderDisabledStyle(item)" v-else>
                {{ item.value }}
              </div>
            </template>
          </v-data-table>
        </td>
      </tr>
    </template>
    <template v-slot:[`item.actions`]="{ item }" v-if="hasAccessRight('data-landscaping-admin')">
      <v-icon size="small" class="me-2"
              v-tooltip="'Edit item'"
              @click.stop="editItem(item)" v-if="item.deleted !== true">mdi-pencil</v-icon>
      <v-icon size="small" class="me-2"
              v-tooltip="'Delete item'"
              @click.stop="deleteItem(item)" v-if="item.deleted !== true">mdi-delete</v-icon>
      <v-icon size="small" class="me-2"
              v-tooltip="'Restore item'"
              @click.stop="restoreItem(item)" v-else>mdi-delete-sweep</v-icon>
    </template>
    <template v-slot:no-data>
      <v-card-text>No data available</v-card-text>
    </template>
  </v-data-table-server>
  <v-navigation-drawer v-model="filter_drawer" location="right" v-bind:width="600">
    <v-card class="mx-auto" elevation="0">
      <v-row no-gutters>
        <v-col>
          <v-list nav dense light>
            <v-list-item title="Filters" nav>
              <template v-slot:prepend>
                <v-btn variant="text" icon="mdi-filter" @click.stop="filter_drawer = !filter_drawer"></v-btn>
              </template>
            </v-list-item>
            <v-divider></v-divider>
            <v-form ref="filter_form">
              <v-row>
                <v-col cols="12">
                  <v-combobox v-model="selectedTherapeuticAreas" :items="therapeuticAreaItems"
                              v-if="therapeuticAreaItems.length > 0"
                              label="Therapeutic Area" :rules="[rules.required]" @click="$refs.filter_form.validate()"
                              multiple></v-combobox>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12">
                  <v-combobox v-model="selectedCountries" :items="countryItems"
                              v-if="countryItems.length > 0"
                              label="Country" :rules="[rules.required]" @click="$refs.filter_form.validate()"
                              multiple></v-combobox>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12">
                  <v-combobox v-model="selectedGeographicalSetUp" :items="geographicalSetUpItems"
                              v-if="geographicalSetUpItems.length > 0"
                              label="Geographical Set-up" :rules="[rules.required]" @click="$refs.filter_form.validate()"
                              multiple></v-combobox>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12">
                  <v-combobox v-model="selectedDataSourceType" :items="dataSourceTypeItems"
                              v-if="dataSourceTypeItems.length > 0"
                              label="Data source type" :rules="[rules.required]" @click="$refs.filter_form.validate()"
                              multiple></v-combobox>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12">
                  <v-combobox v-model="selectedRetrospectiveOrProspectiveCollection"
                              :items="retrospectiveOrProspectiveCollectionItems"
                              v-if="retrospectiveOrProspectiveCollectionItems.length > 0"
                              label="Retrospective or Prospective collection" :rules="[rules.required]" @click="$refs.filter_form.validate()"
                              multiple></v-combobox>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12">
                  <v-combobox v-model="selectedLongitudinalDataCollection"
                              :items="longitudinalDataCollectionItems"
                              v-if="longitudinalDataCollectionItems.length > 0"
                              label="Longitudinal data collection" :rules="[rules.required]" @click="$refs.filter_form.validate()"
                              multiple></v-combobox>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12">
                  <v-combobox v-model="selectedOutreachPerformed"
                              :items="outreachPerformedItems"
                              v-if="outreachPerformedItems.length > 0"
                              label="Outreach performed" :rules="[rules.required]" @click="$refs.filter_form.validate()"
                              multiple></v-combobox>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row align="center">
                <v-col cols="8">
                  <v-label class="mt-2 mb-2">Custom filters</v-label>
                </v-col>
                <v-col cols="4" align="right">
                  <v-btn class="mt-2 mb-2">
                    Add/edit
                    <v-menu activator="parent" :close-on-content-click="false">
                      <v-list v-model:opened="openDataSourceCharacteristicsLabelFilters"
                              v-model:selected="selectedDataSourceCharacteristicsLabelFilters"
                              select-strategy="leaf">
                        <div class="text-center" v-if="dataSourceCharacteristicsSectionFilters.size === 0">
                          <v-progress-circular color="primary" indeterminate></v-progress-circular>
                        </div>
                        <v-list-group v-for="section in Array.from(dataSourceCharacteristicsSectionFilters.keys()).sort()"
                                      :key="section" :value="section">
                          <template v-slot:activator="{ props }">
                            <v-list-item v-bind="props" :title="section" @click="getDataSourceCharacteristicsLabelFilters(section)">
                            </v-list-item>
                          </template>
                          <div class="text-center" v-if="dataSourceCharacteristicsSectionFilters.get(section) === undefined">
                            <v-progress-circular color="primary" indeterminate></v-progress-circular>
                          </div>
                          <div v-else>
                            <v-list-item v-for="label in Array.from(getDataSourceCharacteristicsLabelFilters(section).keys()).sort()"
                                         :key="section + '\\\\' + label" :value="section + '\\\\' + label" :title="label">
                              <template v-slot:prepend="{ isSelected, select }">
                                <v-list-item-action start>
                                  <v-checkbox-btn :model-value="isSelected" @update:model-value="select"></v-checkbox-btn>
                                </v-list-item-action>
                              </template>
                            </v-list-item>
                          </div>
                        </v-list-group>
                      </v-list>
                    </v-menu>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-for="(sectionLabels, i) in explodeSelectedDataSourceCharacteristicsLabelFilters(selectedDataSourceCharacteristicsLabelFilters)" :key="i" no-gutters>
                <v-col cols="12">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-label class="text-wrap" style="font-size: 1em">{{ sectionLabels.section }}</v-label>
                    </v-col>
                  </v-row>
                  <v-row v-for="(label, j) in sectionLabels.labels" :key="j" no-gutters>
                    <v-col cols="12">
                      <v-confirm-edit v-model="selectedDataSourceCharacteristicsValueFilters[sectionLabels.section][label]">
                            <template v-slot:default="{ model: proxyModel, actions, save }">
                              <v-combobox v-model="proxyModel.value"
                                          :items="getDataSourceCharacteristicsLabelFilters(sectionLabels.section)?.get(label)"
                                          :loading="getDataSourceCharacteristicsLabelFilters(sectionLabels.section)?.get(label) === undefined"
                                          :label="label"
                                          @update:model-value="this.handleSelectedDataSourceCharacteristicsValueFilters(
                                              sectionLabels.section, label, $event, selectedDataSourceCharacteristicsValueFilters[sectionLabels.section][label],
                                              save)"
                                          multiple>
                                <template v-slot:actions>
                                  <component :is="actions"></component>
                                </template>
                              </v-combobox>
                            </template>
                      </v-confirm-edit>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-divider thickness="10" opacity="0"></v-divider>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="dataSourcesSearch"
                                @update:model-value="dataSourcesSearchUpdated"
                                label="Search"
                                placeholder="Search"
                                :disabled="loading"
                                hide-details filled dense></v-text-field>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12">
                  <v-checkbox v-model="selectedIncludeOnlyItemsWithDocuments"
                              label="Include only items with attached documents"
                              hide-details></v-checkbox>
                </v-col>
              </v-row>
              <div v-if="hasAccessRight('data-landscaping-admin')">
                <v-row>
                  <v-col cols="12">
                    <v-checkbox v-model="selectedIncludeDeleted" label="Include deleted items"
                                hide-details></v-checkbox>
                  </v-col>
                </v-row>
              </div>
              <v-row>
                <v-col cols="12">
                  <v-card class="mx-auto" min-height="800" elevation="0" title="Geographical distribution">
                    <div>
                      <GChart :settings="{ packages: ['geochart'], mapsApiKey: 'AIzaSyC95Y92u-OHlj8KHIODdWMCTqZe0WqZXZ4' }"
                              type="GeoChart"
                              @ready="regionalMapChartReady"
                              :data="regionalMapChartData"
                              :options="regionalMapChartOptions"
                              v-if="regionalMapChartData.length !== 0">
                      </GChart>
                      <v-chip variant="elevated" size="x-large" density="default" v-else>
                        No data to display. Please adjust your filters.
                      </v-chip>
                      <v-overlay v-model="loading"
                                 class="align-center justify-center"
                                 opacity="0"
                                 contained>
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                      </v-overlay>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
          </v-list>
        </v-col>
      </v-row>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import {defineComponent} from "vue";
import axios from "axios";
import {GChart} from 'vue-google-charts'
import LandscapingDataSourceDetailsCard from "@/components/LandscapingDataSourceDetailsCard.vue";
import LandscapingDataSourceEditCard from "@/components/LandscapingDataSourceEditCard.vue";
import ProgressBar from "primevue/progressbar";
import store from "@/store";

const ANY = 'Any'

function debounce(func, timer, timeout = 1000) {
  return (...args) => {
    if (timer) {
      clearTimeout(timer);
    }
    return setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

function createMap(list, keyExtractor, valueExtractor) {
  let map = new Map();
  list.forEach(item => {
    let key = keyExtractor(item);
    map.set(key, valueExtractor ? valueExtractor(item) : item);
  })
  return map
}

function addItemsIfNotExists(array, items, comparator, hasAny = true) {
  if (hasAny) {
    removeItemsIfExist(array, ANY, a1 => a2 => a1 === a2);
  }
  if (!Array.isArray(items)) {
    items = [items];
  }
  items.forEach(item => {
    if (!array.some(comparator(item))) {
      array.push(item);
    }
  });
  array.sort()
  if (hasAny) {
    array.unshift(ANY)
  }
}

function removeItemsIfExist(array, items, comparator) {
  if (!Array.isArray(items)) {
    items = [items];
  }
  items.forEach(item => {
    array.forEach(a => {
      if (comparator(a)(item)) {
        let index = array.indexOf(a);
        array.splice(index, 1);
      }
    })
  });
}

export default defineComponent({
  name: 'LandscapingDataSourcesPage',
  components: {
    ProgressBar,
    GChart,
    LandscapingDataSourceDetailsCard,
    LandscapingDataSourceEditCard
  },
  data: () => ({
    filter_drawer: false,
    dialog: false,
    dialogDisabled: false,
    dialogModifiedData: false,
    newItemDialog: false,
    editDialog: false,
    deleteDialog: false,
    restoreDialog: false,
    compareDialog: false,
    compareEditDialog: false,
    compareEditDialogModifiedData: false,
    failedLoadVersion: undefined,
    failedSaveNewItem: undefined,
    failedSaveEdit: undefined,
    failedDelete: undefined,
    failedRestore: undefined,
    selected: [],
    itemsPerPage: 15,
    expanded: [],
    sortBy: [{ key: 'name', order: 'asc' }],
    search: '',
    loading: true,
    totalItems: 0,
    currentItem: {},
    currentVersion: undefined,
    currentDelta: {},
    currentCompareItem: {},
    currentCompareItemVersion: undefined,
    currentCompareItemDelta: {},
    headers: [
      {
        title: 'Name',
        align: 'start',
        key: 'name',
        sortable: true,
        width: '60%'
      },
      {
        title: 'Countries',
        key: 'country',
        sortable: true,
        width: '10%'
      },
      {
        title: 'Comment to countries',
        key: 'countryComment',
        sortable: true,
        width: '10%'
      },
      {
        title: 'Therapeutic area',
        key: 'therapeuticArea',
        sortable: false,
        width: '5%'
      },
      {
        title: 'Geographical set-up',
        key: 'geographicalSetUp',
        sortable: false,
        width: '5%'
      },
      {
        title: 'Access',
        key: 'access',
        sortable: false,
        width: '5%'
      },
      {
        title: 'Actions',
        key: 'actions',
        sortable: false,
        width: '5%'
      }
    ],
    dataSources: [],
    groupItems: store.getters.stateUser.groups_by_names,
    customers: new Map(),
    allTherapeuticAreas: [],
    therapeuticAreaItems: [ANY],
    selectedTherapeuticAreas: [ANY],
    allCountries: [],
    countryItems: [ANY],
    selectedCountries: [ANY],
    allGeographicalSetUp: [],
    geographicalSetUpItems: [ANY],
    selectedGeographicalSetUp: [ANY],
    allDataSourceTypes: [],
    dataSourceTypeItems: [ANY],
    selectedDataSourceType: [ANY],
    allRetrospectiveOrProspectiveCollection: [],
    retrospectiveOrProspectiveCollectionItems: [ANY],
    selectedRetrospectiveOrProspectiveCollection: [ANY],
    allLongitudinalDataCollection: [],
    longitudinalDataCollectionItems: [ANY],
    selectedLongitudinalDataCollection: [ANY],
    allOutreachPerformed: [],
    outreachPerformedItems: [ANY],
    selectedOutreachPerformed: [ANY],
    dataSourceCharacteristicsSectionFilters: new Map(),
    selectedDataSourceCharacteristicsLabelFilters: [],
    openDataSourceCharacteristicsLabelFilters: [],
    selectedDataSourceCharacteristicsValueFilters: {},
    dataSourcesSearch: '',
    dataSourcesSearchTimer: undefined,
    selectedIncludeOnlyItemsWithDocuments: false,
    selectedIncludeDeleted: false,
    rules: {
      required(value) {
        if (value instanceof Array && (value.length === 0)) {
          return 'Required.';
        }
        return !!value || 'Required.';
      }
    },
    regionalMapChartData: [],
    regionalMapChartOptions: {
      datalessRegionColor: '#647e91',
      defaultColor: '#647e91',
      backgroundColor: '#364c5b',
      colorAxis: {colors: ['#a9a868', '#b2df8a']},
      height: 800,
      legend: 'none'
    }
  }),

  watch: {
    selectedTherapeuticAreas(newSelectedTherapeuticAreas, oldSelectedTherapeuticAreas) {
      if (((newSelectedTherapeuticAreas.length === 1) && (newSelectedTherapeuticAreas[0] === ANY)) ||
          (!newSelectedTherapeuticAreas.includes(ANY) && !oldSelectedTherapeuticAreas.includes(ANY))) {
        this.filterDataSources()
        return
      }

      if (newSelectedTherapeuticAreas.includes(ANY) && !oldSelectedTherapeuticAreas.includes(ANY)) {
        this.selectedTherapeuticAreas = [ANY]
      } else if (newSelectedTherapeuticAreas.includes(ANY) && oldSelectedTherapeuticAreas.includes(ANY)) {
        this.selectedTherapeuticAreas = this.selectedTherapeuticAreas.filter(c => c !== ANY)
      }
      this.filterDataSources()
    },

    selectedCountries(newSelectedCountries, oldSelectedCountries) {
      if (((newSelectedCountries.length === 1) && (newSelectedCountries[0] === ANY)) ||
          (!newSelectedCountries.includes(ANY) && !oldSelectedCountries.includes(ANY))) {
        this.filterDataSources()
        return
      }

      if (newSelectedCountries.includes(ANY) && !oldSelectedCountries.includes(ANY)) {
        this.selectedCountries = [ANY]
      } else if (newSelectedCountries.includes(ANY) && oldSelectedCountries.includes(ANY)) {
        this.selectedCountries = this.selectedCountries.filter(c => c !== ANY)
      }
      this.filterDataSources()
    },

    selectedGeographicalSetUp(newSelectedGeographicalSetUp, oldSelectedGeographicalSetUp) {
      if (((newSelectedGeographicalSetUp.length === 1) && (newSelectedGeographicalSetUp[0] === ANY)) ||
          (!newSelectedGeographicalSetUp.includes(ANY) && !oldSelectedGeographicalSetUp.includes(ANY))) {
        this.filterDataSources()
        return
      }

      if (newSelectedGeographicalSetUp.includes(ANY) && !oldSelectedGeographicalSetUp.includes(ANY)) {
        this.selectedGeographicalSetUp = [ANY]
      } else if (newSelectedGeographicalSetUp.includes(ANY) && oldSelectedGeographicalSetUp.includes(ANY)) {
        this.selectedGeographicalSetUp = this.selectedGeographicalSetUp.filter(c => c !== ANY)
      }
      this.filterDataSources()
    },

    selectedDataSourceType(newSelectedDataSourceType, oldSelectedDataSourceType) {
      if (((newSelectedDataSourceType.length === 1) && (newSelectedDataSourceType[0] === ANY)) ||
          (!newSelectedDataSourceType.includes(ANY) && !oldSelectedDataSourceType.includes(ANY))) {
        this.filterDataSources()
        return
      }

      if (newSelectedDataSourceType.includes(ANY) && !oldSelectedDataSourceType.includes(ANY)) {
        this.selectedDataSourceType = [ANY]
      } else if (newSelectedDataSourceType.includes(ANY) && oldSelectedDataSourceType.includes(ANY)) {
        this.selectedDataSourceType = this.selectedDataSourceType.filter(c => c !== ANY)
      }
      this.filterDataSources()
    },

    selectedRetrospectiveOrProspectiveCollection(newSelectedRetrospectiveOrProspectiveCollection,
                                                 oldSelectedRetrospectiveOrProspectiveCollection) {
      if (((newSelectedRetrospectiveOrProspectiveCollection.length === 1) && (newSelectedRetrospectiveOrProspectiveCollection[0] === ANY)) ||
          (!newSelectedRetrospectiveOrProspectiveCollection.includes(ANY) && !oldSelectedRetrospectiveOrProspectiveCollection.includes(ANY))) {
        this.filterDataSources()
        return
      }

      if (newSelectedRetrospectiveOrProspectiveCollection.includes(ANY) && !oldSelectedRetrospectiveOrProspectiveCollection.includes(ANY)) {
        this.selectedRetrospectiveOrProspectiveCollection = [ANY]
      } else if (newSelectedRetrospectiveOrProspectiveCollection.includes(ANY) && oldSelectedRetrospectiveOrProspectiveCollection.includes(ANY)) {
        this.selectedRetrospectiveOrProspectiveCollection = this.selectedRetrospectiveOrProspectiveCollection.filter(c => c !== ANY)
      }
      this.filterDataSources()
    },

    selectedLongitudinalDataCollection(newSelectedLongitudinalDataCollection, oldSelectedLongitudinalDataCollection) {
      if (((newSelectedLongitudinalDataCollection.length === 1) && (newSelectedLongitudinalDataCollection[0] === ANY)) ||
          (!newSelectedLongitudinalDataCollection.includes(ANY) && !oldSelectedLongitudinalDataCollection.includes(ANY))) {
        this.filterDataSources()
        return
      }

      if (newSelectedLongitudinalDataCollection.includes(ANY) && !oldSelectedLongitudinalDataCollection.includes(ANY)) {
        this.selectedLongitudinalDataCollection = [ANY]
      } else if (newSelectedLongitudinalDataCollection.includes(ANY) && oldSelectedLongitudinalDataCollection.includes(ANY)) {
        this.selectedLongitudinalDataCollection = this.selectedLongitudinalDataCollection.filter(c => c !== ANY)
      }
      this.filterDataSources()
    },

    selectedOutreachPerformed(newSelectedOutreachPerformed, oldSelectedOutreachPerformed) {
      if (((newSelectedOutreachPerformed.length === 1) && (newSelectedOutreachPerformed[0] === ANY)) ||
          (!newSelectedOutreachPerformed.includes(ANY) && !oldSelectedOutreachPerformed.includes(ANY))) {
        this.filterDataSources()
        return
      }

      if (newSelectedOutreachPerformed.includes(ANY) && !oldSelectedOutreachPerformed.includes(ANY)) {
        this.selectedOutreachPerformed = [ANY]
      } else if (newSelectedOutreachPerformed.includes(ANY) && oldSelectedOutreachPerformed.includes(ANY)) {
        this.selectedOutreachPerformed = this.selectedOutreachPerformed.filter(c => c !== ANY)
      }
      this.filterDataSources()
    },

    selectedIncludeDeleted() {
      this.filterDataSources()
    },

    selectedIncludeOnlyItemsWithDocuments() {
      this.filterDataSources()
    },

    selectedDataSourceCharacteristicsLabelFilters: {
      deep: true,
      handler: function(newSelectedDataSourceCharacteristicsLabelFilters, oldSelectedDataSourceCharacteristicsLabelFilters) {
        const added = newSelectedDataSourceCharacteristicsLabelFilters.filter(
            item => !oldSelectedDataSourceCharacteristicsLabelFilters.includes(item)
        );
        for (const sectionLabel of added) {
          let [section, label] = sectionLabel.split('\\\\')
          if (this.selectedDataSourceCharacteristicsValueFilters[section][label] === undefined) {
            this.selectedDataSourceCharacteristicsValueFilters[section][label] = [ANY]
          }
          this.getDataSourceCharacteristicsValueFilters(section, label)
        }
        this.filterDataSources()
      }
    }
  },

  methods: {
    hasAccessRight(accessRight) {
      return this.$store.getters.stateUser?.access_rights?.includes(accessRight);
    },
    async loadLandscapingDataSources(page, itemsPerPage, sortBy) {
      let formData = this.createFormDataForFetch()
      let data = axios.post('/data-landscaping/data-sources',
          Array.from(formData.keys()).length > 0 ? formData : undefined, {
            headers: {
              Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}`,
              'X-HTTP-Method-Override': 'GET'},
            params: {
              include_only_items_with_documents: this.selectedIncludeOnlyItemsWithDocuments,
              include_deleted: this.selectedIncludeDeleted,
              page: page,
              items_per_page: itemsPerPage,
              sort_by: sortBy.map(sort => sort.key + ':' + sort.order).join(",")
            }
          });
      return data.then((response) => {
        return {
          items: response.data.items,
          total: response.data.total
        }
      });
    },

    async patchLandscapingDataSource(id, version, itemData) {
      const formData = new FormData();
      formData.append("data", JSON.stringify(itemData))
      formData.append("version", version)
      let data = axios.patch('/data-landscaping/data-sources/' + id,
          formData,
          {
            headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` }
          });
      return data.then((response) => {
        return [response.data.patch, response.data.delta]
      });
    },

    async loadLandscapingDataSourcesMetaData() {
      let formData = this.createFormDataForFetch()
      return axios.post('/data-landscaping/data-source-metadata',
          Array.from(formData.keys()).length > 0 ? formData : undefined, {
            headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}`,
              'X-HTTP-Method-Override': 'GET'},
            params: {
              include_only_items_with_documents: this.selectedIncludeOnlyItemsWithDocuments,
              include_deleted: this.selectedIncludeDeleted
            }
          });
    },

    async loadLandscapingDataSourcesCharacteristicsLabels(section) {
      return axios.get('/data-landscaping/data-source-characteristics-labels',
          {
            headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` },
            params: {
              section: section
            }
          });
    },

    async loadLandscapingDataSourcesCharacteristicsLabelValues(section, label) {
      return axios.get('/data-landscaping/data-source-characteristics-values',
          {
            headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` },
            params: {
              section: section,
              label: label
            }
          });
    },

    createFormDataForFetch() {
      const formData = new FormData();
      if (!this.selectedTherapeuticAreas.includes(ANY)) {
        this.selectedTherapeuticAreas.forEach(ta => formData.append("therapeutic_area", ta))
      }
      if (!this.selectedCountries.includes(ANY)) {
        this.selectedCountries.forEach(ta => formData.append("country", ta))
      }
      if (!this.selectedGeographicalSetUp.includes(ANY)) {
        this.selectedGeographicalSetUp.forEach(ta => formData.append("geographical_set_up", ta))
      }
      if (!this.selectedDataSourceType.includes(ANY)) {
        this.selectedDataSourceType.forEach(ta => formData.append("data_source_type", ta))
      }
      if (!this.selectedRetrospectiveOrProspectiveCollection.includes(ANY)) {
        this.selectedRetrospectiveOrProspectiveCollection.forEach(ta => formData.append("retrospective_or_prospective_collection", ta))
      }
      if (!this.selectedLongitudinalDataCollection.includes(ANY)) {
        this.selectedLongitudinalDataCollection.forEach(ta => formData.append("longitudinal_data_collection", ta))
      }
      if (!this.selectedOutreachPerformed.includes(ANY)) {
        this.selectedOutreachPerformed.forEach(ta => formData.append("outreach_performed", ta))
      }
      let explodeSelectedDataSourceCharacteristicsLabelFilters =
          this.explodeSelectedDataSourceCharacteristicsLabelFilters(this.selectedDataSourceCharacteristicsLabelFilters)
      let selectedDataSourceCharacteristicsValueFilters = structuredClone(this.selectedDataSourceCharacteristicsValueFilters)
      for (const selectedSection of Object.keys(selectedDataSourceCharacteristicsValueFilters)) {
        let explodedValue = explodeSelectedDataSourceCharacteristicsLabelFilters.find(v => v.section === selectedSection)
        if (explodedValue === undefined) {
          delete selectedDataSourceCharacteristicsValueFilters[selectedSection]
        } else {
          for (const label of Object.keys(selectedDataSourceCharacteristicsValueFilters[selectedSection])) {
            let explodedLabel = explodedValue.labels.find(v => v === label)
            if (explodedLabel === undefined) {
              delete selectedDataSourceCharacteristicsValueFilters[selectedSection][label]
            } else if (selectedDataSourceCharacteristicsValueFilters[selectedSection][label].includes(ANY)) {
              selectedDataSourceCharacteristicsValueFilters[selectedSection][label] = []
            }
          }
        }
      }
      if (Object.keys(selectedDataSourceCharacteristicsValueFilters).length > 0) {
        formData.append("data_source_characteristics_value", JSON.stringify(selectedDataSourceCharacteristicsValueFilters))
      }
      if (this.dataSourcesSearch !== '') {
        formData.append("search", this.dataSourcesSearch)
      }
      return formData
    },

    explodeSelectedDataSourceCharacteristicsLabelFilters(selectedDataSourceCharacteristicsLabelFilters) {
      let returnValue = []
      for (const sectionLabel of selectedDataSourceCharacteristicsLabelFilters) {
        let [section, label] = sectionLabel.split('\\\\')
        let existingSection = returnValue.find(v => v['section'] === section)
        if (existingSection !== undefined) {
          existingSection['labels'].push(label)
        }
        else {
          returnValue.push({
            'section': section,
            'labels': [label]
          })
        }
      }
      returnValue.sort((a, b) => {
        if (a.section < b.section) {
          return -1
        }
        else if (a.section > b.section) {
          return 1
        }
        else {
          return 0
        }
      })
      for (const section of returnValue) {
        section.labels.sort()
      }
      return returnValue
    },

    getDataSourceCharacteristicsLabelFilters(section) {
      let existing = this.dataSourceCharacteristicsSectionFilters.get(section)
      if (existing !== undefined) {
        return existing
      }
      return this.loadLandscapingDataSourcesCharacteristicsLabels(section)
          .then((response) => {
            this.dataSourceCharacteristicsSectionFilters.set(section, createMap(
                response.data, item => item, () => undefined)
            )
            this.selectedDataSourceCharacteristicsValueFilters[section] = {}
            for (const element of response.data) {
              this.selectedDataSourceCharacteristicsValueFilters[section][element] = undefined
            }
            return this.dataSourceCharacteristicsSectionFilters.get(section)
          })
    },

    getDataSourceCharacteristicsValueFilters(section, label) {
      let existingSection = this.getDataSourceCharacteristicsLabelFilters(section)
      let existing = existingSection.get(label)
      if (existing !== undefined) {
        return existing
      }
      return this.loadLandscapingDataSourcesCharacteristicsLabelValues(section, label)
          .then((response) => {
            existingSection.set(label, response.data)
            existingSection.get(label).unshift(ANY)
            return existingSection.get(label)
          })
    },

    handleSelectedDataSourceCharacteristicsValueFilters(section, label,
                                                        newSelectedDataSourceCharacteristicsValueFilters,
                                                        oldSelectedDataSourceCharacteristicsValueFilters,
                                                        save) {
      if (((newSelectedDataSourceCharacteristicsValueFilters.length === 1) && (newSelectedDataSourceCharacteristicsValueFilters[0] === ANY)) ||
          (!newSelectedDataSourceCharacteristicsValueFilters.includes(ANY) && !oldSelectedDataSourceCharacteristicsValueFilters.includes(ANY))) {
        save()
        this.filterDataSources()
        return
      }

      if (newSelectedDataSourceCharacteristicsValueFilters.includes(ANY) && !oldSelectedDataSourceCharacteristicsValueFilters.includes(ANY)) {
        this.selectedDataSourceCharacteristicsValueFilters[section][label] = [ANY]
      } else if (newSelectedDataSourceCharacteristicsValueFilters.includes(ANY) && oldSelectedDataSourceCharacteristicsValueFilters.includes(ANY)) {
        this.selectedDataSourceCharacteristicsValueFilters[section][label] = newSelectedDataSourceCharacteristicsValueFilters.filter(c => c !== ANY)
      } else {
        save()
      }
      this.filterDataSources()
    },

    async saveNewLandscapingDataSource([data, deletedFiles, newFiles], onSuccess) {
      this.dialogDisabled = true
      const formData = new FormData();
      formData.append("data", JSON.stringify(data))
      if (deletedFiles.length > 0) {
        throw new Error('Deleted files should not be passed with a new item');
      }
      newFiles.forEach(f => {
        formData.append("new_files", f);
      })
      let response = axios.post('/data-landscaping/data-sources', formData, {
        headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` }
      });
      response.then(() => {
        addItemsIfNotExists(this.allTherapeuticAreas, data.therapeuticArea, t1 => t2 => t1 === t2, false)
        addItemsIfNotExists(this.therapeuticAreaItems, data.therapeuticArea, t1 => t2 => t1 === t2)
        addItemsIfNotExists(this.allCountries, data.country, t1 => t2 => t1 === t2, false)
        addItemsIfNotExists(this.countryItems, data.country, t1 => t2 => t1 === t2)
        addItemsIfNotExists(this.allGeographicalSetUp, data.geographicalSetUp, t1 => t2 => t1 === t2, false)
        addItemsIfNotExists(this.geographicalSetUpItems, data.geographicalSetUp, t1 => t2 => t1 === t2)
        addItemsIfNotExists(this.allDataSourceTypes, data.dataSourceType, t1 => t2 => t1 === t2, false)
        addItemsIfNotExists(this.dataSourceTypeItems, data.dataSourceType, t1 => t2 => t1 === t2)
        addItemsIfNotExists(this.retrospectiveOrProspectiveCollectionItems, data.retrospectiveOrProspectiveCollection, t1 => t2 => t1 === t2)
        addItemsIfNotExists(this.longitudinalDataCollectionItems, data.longitudinalDataCollection, t1 => t2 => t1 === t2)
        addItemsIfNotExists(this.outreachPerformedItems, data.outreachPerformed, t1 => t2 => t1 === t2)
        // Note: Need to call filterDataSources() since the watch is not triggered by the update
        this.filterDataSources()
        this.failedSaveNewItem = undefined
        onSuccess()
      }).catch(err => {
        if (err.response.status === 413) {
          this.failedSaveNewItem = err.response.data.detail
        }
        else {
          this.failedSaveNewItem = 'Failed to save data source!'
        }
        console.log(err);
      }).finally(() => {
        this.dialogDisabled = false
      });
    },

    async saveEditedLandscapingDataSource([data, deletedFiles, newFiles], onSuccess) {
      this.dialogDisabled = true
      const formData = new FormData();
      formData.append("data", JSON.stringify(data))
      newFiles.forEach(f => {
        formData.append("new_files", f);
      })
      formData.append("deleted_files", JSON.stringify(deletedFiles));
      let response = axios.put('/data-landscaping/data-sources/' + data['id'], formData, {
        headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` }
      });
      response.then(() => {
        addItemsIfNotExists(this.allTherapeuticAreas, data.therapeuticArea, t1 => t2 => t1 === t2, false)
        addItemsIfNotExists(this.therapeuticAreaItems, data.therapeuticArea, t1 => t2 => t1 === t2)
        addItemsIfNotExists(this.allCountries, data.country, t1 => t2 => t1 === t2, false)
        addItemsIfNotExists(this.countryItems, data.country, t1 => t2 => t1 === t2)
        addItemsIfNotExists(this.allGeographicalSetUp, data.geographicalSetUp, t1 => t2 => t1 === t2, false)
        addItemsIfNotExists(this.geographicalSetUpItems, data.geographicalSetUp, t1 => t2 => t1 === t2)
        addItemsIfNotExists(this.allDataSourceTypes, data.dataSourceType, t1 => t2 => t1 === t2, false)
        addItemsIfNotExists(this.dataSourceTypeItems, data.dataSourceType, t1 => t2 => t1 === t2)
        addItemsIfNotExists(this.retrospectiveOrProspectiveCollectionItems, data.retrospectiveOrProspectiveCollection, t1 => t2 => t1 === t2)
        addItemsIfNotExists(this.longitudinalDataCollectionItems, data.longitudinalDataCollection, t1 => t2 => t1 === t2)
        addItemsIfNotExists(this.outreachPerformedItems, data.outreachPerformed, t1 => t2 => t1 === t2)
        // Note: Need to call filterDataSources() since the watch is not triggered by the update
        this.filterDataSources()
        this.failedSaveEdit = undefined
        onSuccess()
      }).catch(err => {
        if (err.response.status === 413) {
          this.failedSaveEdit = err.response.data.detail
        }
        else {
          this.failedSaveEdit = 'Failed to save data source!'
        }
        console.log(err);
      }).finally(() => {
        this.dialogDisabled = false
      });
    },

    async loadCustomers() {
      return axios.get('/customers',
          {
            headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` },
            params: {}
          });
    },

    async loadNextVersion(item, setter) {
      this.dialogDisabled = true
      return this.patchLandscapingDataSource(item.id, item.version + 1, item).then(([patch, delta]) => {
        setter(patch, delta)
        this.failedLoadVersion = undefined
        return delta
      }).catch(err => {
        this.failedLoadVersion = 'Failed to load next version!'
        console.log(err);
      }).finally(() => {
        this.dialogDisabled = false
      });
    },

    async loadPreviousVersion(item, setter) {
      this.dialogDisabled = true
      return this.patchLandscapingDataSource(item.id, item.version - 1, item).then(([patch, delta]) => {
        setter(patch, delta)
        this.failedLoadVersion = undefined
        return delta
      }).catch(err => {
        this.failedLoadVersion = 'Failed to load previous version!'
        console.log(err);
      }).finally(() => {
        this.dialogDisabled = false
      });
    },

    downloadExcel() {
      this.loading = true
      let formData = this.createFormDataForFetch()
      axios.post('/data-landscaping/data-sources-excel',
                Array.from(formData.keys()).length > 0 ? formData : undefined, {
            headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}`,
              'X-HTTP-Method-Override': 'GET'},
            params: {
              include_only_items_with_documents: this.selectedIncludeOnlyItemsWithDocuments,
              include_deleted: this.selectedIncludeDeleted,
              sort_by: this.sortBy.map(sort => sort.key + ':' + sort.order).join(",")
            },
            responseType: 'blob'
          })
          .then((response) => {
            const href = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('target', '_blank');
            link.click();
            URL.revokeObjectURL(href);
          })
          .finally(() => {
            this.loading = false
          });
    },

    async loadStaticData() {
      return await Promise.all([
        this.loadCustomers(),
        this.loadLandscapingDataSourcesMetaData()
      ]).then((response) => {
        this.customers = createMap(response[0].data, item => item['id'])
        this.allTherapeuticAreas = [...response[1].data.allTherapeuticAreas]
        this.therapeuticAreaItems = [...response[1].data.allTherapeuticAreas]
        this.therapeuticAreaItems.unshift(ANY)
        this.allCountries = [...response[1].data.allCountries]
        this.countryItems = [...response[1].data.allCountries]
        this.countryItems.unshift(ANY)
        this.regionalMapChartData = response[1].data.countryCounts;
        this.allGeographicalSetUp = [...response[1].data.allGeographicalSetup]
        this.geographicalSetUpItems = [...response[1].data.allGeographicalSetup]
        this.geographicalSetUpItems.unshift(ANY)
        this.allDataSourceTypes = [...response[1].data.allDataSourceTypes]
        this.dataSourceTypeItems = [...response[1].data.allDataSourceTypes]
        this.dataSourceTypeItems.unshift(ANY)
        this.allRetrospectiveOrProspectiveCollection = [...response[1].data.allRetrospectiveOrProspectiveCollection]
        this.retrospectiveOrProspectiveCollectionItems = [...response[1].data.allRetrospectiveOrProspectiveCollection]
        this.retrospectiveOrProspectiveCollectionItems.unshift(ANY)
        this.allLongitudinalDataCollection = [...response[1].data.allLongitudinalDataCollection]
        this.longitudinalDataCollectionItems = [...response[1].data.allLongitudinalDataCollection]
        this.longitudinalDataCollectionItems.unshift(ANY)
        this.allOutreachPerformed = [...response[1].data.allOutreachPerformed]
        this.outreachPerformedItems = [...response[1].data.allOutreachPerformed]
        this.outreachPerformedItems.unshift(ANY)
        this.dataSourceCharacteristicsSectionFilters = createMap(response[1].data.dataSourceCharacteristicsSections,
            item => item, () => undefined)
        console.log('Static data loaded: LandscapingDataSources')
      })
    },

    loadItems({ page, itemsPerPage, sortBy }) {
      this.loading = true
      return Promise.all([
          this.loadLandscapingDataSources(page, itemsPerPage, sortBy),
          this.loadLandscapingDataSourcesMetaData()
      ]).then(((response) => {
        this.dataSources = response[0].items;
        this.totalItems = response[0].total;
        this.regionalMapChartData = response[1].data.countryCounts;
      })).finally(() => {
        this.loading = false
        console.log('Landscaping data sources loaded')
      })
    },

    filterDataSources() {
      // Triggers an event for searching
      this.search = String(Date.now())
    },

    rowProps() {
      return {
        class: "ciencia_row"
      };
    },

    handleRowClicked(event, row) {
      this.currentItem = row.item
      this.currentVersion = this.currentItem.version
      if (this.selected?.length === 1) {
        let selected = this.selected[0]
        this.currentCompareItem = structuredClone(selected)
        this.currentCompareItemVersion = this.currentCompareItem.version
        this.compareDialog = true
      } else {
        this.dialog = true
      }
    },

    newItem() {
      this.currentItem = {}
      this.currentVersion = undefined
      this.currentDelta = {}
      this.failedSaveNewItem = undefined
      this.newItemDialog = true
    },

    editItem(item) {
      this.currentItem = structuredClone(item)
      this.currentVersion = this.currentItem.version
      this.failedSaveEdit = undefined
      if (this.selected?.length === 1) {
        let selected = this.selected[0]
        this.currentCompareItem = structuredClone(selected)
        this.currentCompareItemVersion = this.currentCompareItem.version
        this.compareEditDialog = true
      } else {
        this.editDialog = true
      }
    },

    deleteItem(item) {
      this.currentItem = structuredClone(item)
      this.currentVersion = this.currentItem.version
      this.failedDelete = undefined
      this.deleteDialog = true
    },

    restoreItem(item) {
      this.currentItem = structuredClone(item)
      this.currentVersion = this.currentItem.version
      this.failedRestore = undefined
      this.restoreDialog = true
    },

    deleteItemConfirm() {
      this.dialogDisabled = true
      let response = axios.delete('/data-landscaping/data-sources/' + this.currentItem['id'], {
        headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` }
      });
      response.then(() => {
        // Note: Need to call filterDataSources() since the watch is not triggered by the update
        this.filterDataSources()
        this.failedDelete = undefined
        this.deleteDialog = false
      }).catch(err => {
        this.failedDelete = 'Failed to delete data source!'
        console.log(err);
      }).finally(() => {
        this.dialogDisabled = false
      });
    },

    restoreItemConfirm() {
      this.dialogDisabled = true
      const formData = new FormData();
      this.currentItem['deleted'] = false
      formData.append("data", JSON.stringify(this.currentItem))
      formData.append("deleted_files", JSON.stringify([]));
      let response = axios.put('/data-landscaping/data-sources/' + this.currentItem['id'], formData, {
        headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` }
      });
      response.then(() => {
        // Note: Need to call filterDataSources() since the watch is not triggered by the update
        this.filterDataSources()
        this.failedRestore = undefined
        this.restoreDialog = false
      }).catch(err => {
        this.failedRestore = 'Failed to restore data source!'
        console.log(err);
      }).finally(() => {
        this.dialogDisabled = false
      });
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.currentItem = {}
        this.currentVersion = undefined
        this.currentDelta = {}
      })
    },

    closeDeleteDialog() {
      this.deleteDialog = false
      this.$nextTick(() => {
        this.currentItem = {}
        this.currentVersion = undefined
        this.currentDelta = {}
      })
    },

    closeRestoreDialog() {
      this.restoreDialog = false
      this.$nextTick(() => {
        this.currentItem = {}
        this.currentVersion = undefined
        this.currentDelta = {}
      })
    },

    closeNewItemDialog() {
      this.newItemDialog = false
      this.$nextTick(() => {
        this.currentItem = {}
        this.currentVersion = undefined
        this.currentDelta = {}
      })
    },

    closeEditDialog() {
      this.editDialog = false
      this.$nextTick(() => {
        this.currentItem = {}
        this.currentVersion = undefined
        this.currentDelta = {}
      })
    },

    closeCompareDialog() {
      this.compareDialog = false
      this.$nextTick(() => {
        this.currentCompareItem = {}
        this.currentCompareItemVersion = undefined
        this.currentCompareItemDelta = {}
        this.currentItem = {}
        this.currentVersion = undefined
        this.currentDelta = {}
      })
    },

    closeCompareEditDialog() {
      this.compareEditDialog = false
      this.$nextTick(() => {
        this.currentCompareItem = {}
        this.currentCompareItemVersion = undefined
        this.currentCompareItemDelta = {}
        this.currentItem = {}
        this.currentVersion = undefined
        this.currentDelta = {}
      })
    },

    toggleAllOneCountries(country) {
      if ((this.selectedCountries.length === 1) && (this.selectedCountries[0] === country)) {
        this.selectedCountries = [...this.countryItems]
      } else {
        this.selectedCountries = [country]
      }
    },

    toggleAllOneTherapeuticAreas(therapeuticArea) {
      if ((this.selectedTherapeuticAreas.length === 1) && (this.selectedTherapeuticAreas[0] === therapeuticArea)) {
        this.selectedTherapeuticAreas = [...this.therapeuticAreaItems]
      } else {
        this.selectedTherapeuticAreas = [therapeuticArea]
      }
    },

    toggleAllOneGeographicalSetUp(geographicalSetUp) {
      if ((this.selectedGeographicalSetUp.length === 1) && (this.selectedGeographicalSetUp[0] === geographicalSetUp)) {
        this.selectedGeographicalSetUp = [...this.geographicalSetUpItems]
      } else {
        this.selectedGeographicalSetUp = [geographicalSetUp]
      }
    },

    toggleAllOneDataSourceType(dataSourceType) {
      if ((this.selectedDataSourceType.length === 1) && (this.selectedDataSourceType[0] === dataSourceType)) {
        this.selectedDataSourceType = [...this.dataSourceTypeItems]
      } else {
        this.selectedDataSourceType = [dataSourceType]
      }
    },

    toggleAllOneRetrospectiveOrProspectiveCollection(retrospectiveOrProspectiveCollection) {
      if ((this.selectedRetrospectiveOrProspectiveCollection.length === 1) && (this.selectedRetrospectiveOrProspectiveCollection[0] === retrospectiveOrProspectiveCollection)) {
        this.selectedRetrospectiveOrProspectiveCollection = [...this.retrospectiveOrProspectiveCollectionItems]
      } else {
        this.selectedRetrospectiveOrProspectiveCollection = [retrospectiveOrProspectiveCollection]
      }
    },

    toggleAllOneLongitudinalDataCollection(longitudinalDataCollection) {
      if ((this.selectedLongitudinalDataCollection.length === 1) && (this.selectedLongitudinalDataCollection[0] === longitudinalDataCollection)) {
        this.selectedLongitudinalDataCollection = [...this.longitudinalDataCollectionItems]
      } else {
        this.selectedLongitudinalDataCollection = [longitudinalDataCollection]
      }
    },

    toggleAllOneOutreachPerformed(outreachPerformed) {
      if ((this.selectedOutreachPerformed.length === 1) && (this.selectedOutreachPerformed[0] === outreachPerformed)) {
        this.selectedOutreachPerformed = [...this.outreachPerformedItems]
      } else {
        this.selectedOutreachPerformed = [outreachPerformed]
      }
    },

    dataSourcesSearchUpdated() {
      this.dataSourcesSearchTimer = debounce(() => this.filterDataSources(), this.dataSourcesSearchTimer)()
    },

    async regionalMapChartReady(chart, google) {
      const setRegionalMapChartSelection = (selectedRow) => {
        let selected_region = this.regionalMapChartData[selectedRow + 1][0].f
        if (selected_region !== undefined) {
          this.toggleAllOneCountries(selected_region)
        }
      }

      const regionSelectHandler = function () {
        const selection = chart.getSelection()
        if (selection.length === 0) {
          return
        }
        const selectedItem = selection[0];
        setRegionalMapChartSelection(selectedItem.row)
      }

      google.visualization.events.addListener(chart, 'select', regionSelectHandler);
    },

    renderDisabledStyle(item) {
      return (item.deleted === true) ? 'color:darkgrey' : '';
    },
  },

  async mounted() {
    await this.loadStaticData()
  }
})
</script>

<style lang="scss" scoped>
.dp__theme_dark {
  --dp-background-color: #364c5b;
  --dp-text-color: #dcdcdc;
  --dp-border-color: #dcdcdc;
}
.error {
  color: indianred;
}

@layer primevue {
  .p-progressbar {
    background-color: #364c5b;
  }
}

::v-deep .ciencia_row:hover {
  background-color: #566c7b;
}
</style>
